import { defineStore } from 'pinia';

import { TBannerType } from '@/composables/useBanner/types';

interface IBannerState {
  readonly items: Record<string, TBannerType[]>
}

export const useBannersStore = defineStore('banners', {
  state: (): IBannerState => ({
    items: {},
  }),

  actions: {
    setBanner(key: string, banners: TBannerType[]) {
      const list = banners.sort((a, b) => {
        if (a.sort !== undefined && b.sort !== undefined) {
          return a.sort - b.sort;
        }
        return 0;
      });

      this.items[key] = list;
    },
  },
});
